class GlobalChatbotTimer {
  private static instance: GlobalChatbotTimer;
  private startTime: number | null = null;
  private timeout: NodeJS.Timeout | null = null;
  private callbacks: (() => void)[] = [];
  private isShown = false;
  private delay: number = 5000; // Default 5 saniye

  private constructor() {}

  public static getInstance(): GlobalChatbotTimer {
    if (!GlobalChatbotTimer.instance) {
      GlobalChatbotTimer.instance = new GlobalChatbotTimer();
    }
    return GlobalChatbotTimer.instance;
  }

  public start(customDelay?: number): void {
    // Eğer timer zaten başlatılmışsa, sadece delay'i güncelle
    if (this.startTime !== null) {
      if (customDelay) {
        this.delay = customDelay;
      }
      return;
    }
    
    if (customDelay) {
      this.delay = customDelay;
    }
    
    this.startTime = Date.now();
    this.timeout = setTimeout(() => {
      this.triggerChatbot();
    }, this.delay);
  }

  public addCallback(callback: () => void): void {
    this.callbacks.push(callback);
    
    if (this.shouldShowChatbot()) {
      callback();
    }
  }

  public removeCallback(callback: () => void): void {
    this.callbacks = this.callbacks.filter(cb => cb !== callback);
  }

  private shouldShowChatbot(): boolean {
    if (this.startTime === null) return false;
    return Date.now() - this.startTime >= this.delay;
  }

  private triggerChatbot(): void {
    if (this.isShown) return;
    
    this.isShown = true;
    this.callbacks.forEach(callback => callback());
  }

  public reset(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.startTime = null;
    this.timeout = null;
    this.callbacks = [];
    this.isShown = false;
  }
}

const globalChatbotTimer = GlobalChatbotTimer.getInstance();
export default globalChatbotTimer;